import {URL_BASE_API } from '../configs/urlConfigs';
import {FEEDBACK_DATA_VIEW_TYPE_CLIENT,FEEDBACK_DATA_VIEW_TYPE_CHIEF} from '../configs/staticConfigs';
import service from './api';

export const feedbackList =(request) =>{  
    let ENDPOINT = '';  
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy; 
        let search   = request.data.search && request.data.search.trim().length > 0 ? request.data.search: 0;  
        ENDPOINT = URL_BASE_API+'events/get-shift-feedback-data/?column='+sortBy+'&page='+page+'&page_size='+pageSize+'&type='+request.data.dataViewType;
        if(search.length > 0) ENDPOINT += '&search='+search;

        // {clientsIds:arrClientIds, eventIds:arrEventIds, starRatingIds:arrStarRatingIds, selectedStartDate:fromDate, selectedEndDate:endDate, filtersSelected:filtersSelected}; 
        // /events/get-shift-feedback-data/?filter=1&clients=[2]&events=[74]&page_size=10&ratings=[4]&from_date=2020-06-01&to_date=2020-08-20 For Search: 127.0.0.1:8000/events/get-shift-feedback-data/?search=2 
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 

        let clientsIds = 0; 
        if(filtersData.clientsIds && filtersData.clientsIds.length)  clientsIds = JSON.stringify(filtersData.clientsIds); 
        if(clientsIds)  ENDPOINT += '&clients='+clientsIds; 

        let eventIds = 0; 
        if(filtersData.eventIds && filtersData.eventIds.length)  eventIds = JSON.stringify(filtersData.eventIds); 
        if(eventIds)  ENDPOINT += '&events='+eventIds;

        let reviewerIds = 0; 
        if(request.data.dataViewType===FEEDBACK_DATA_VIEW_TYPE_CLIENT) {
            if(filtersData.reviewerIds && filtersData.reviewerIds.length)  reviewerIds = JSON.stringify(filtersData.reviewerIds); 
            if(reviewerIds)  ENDPOINT += '&reviewers='+reviewerIds;
        }
        
        let chiefReviewerIds = 0; 
        if(request.data.dataViewType===FEEDBACK_DATA_VIEW_TYPE_CHIEF) {
            if(filtersData.chiefReviewerIds && filtersData.chiefReviewerIds.length)  chiefReviewerIds = JSON.stringify(filtersData.chiefReviewerIds); 
            if(chiefReviewerIds)  ENDPOINT += '&chiefs='+chiefReviewerIds;
        }
        
        let starRatingIds = 0; 
        if(filtersData.starRatingIds && filtersData.starRatingIds.length)  starRatingIds = JSON.stringify(filtersData.starRatingIds); 
        if(starRatingIds)  ENDPOINT += '&ratings='+starRatingIds;

        if(filtersData.selectedStartDate && filtersData.selectedStartDate.length > 1) ENDPOINT += '&from_date='+filtersData.selectedStartDate;

        if(filtersData.selectedEndDate && filtersData.selectedEndDate.length > 1) ENDPOINT += '&to_date='+filtersData.selectedEndDate;
        
        if(filtersData.actionTaken!=='') {
            let actionTaken = (parseInt(filtersData.actionTaken,10)==0) ? 'all' : filtersData.actionTaken; 
            ENDPOINT += '&action_taken='+actionTaken;
        }
        if(filtersData.clientFeedback!=='') { 
            ENDPOINT += '&client_feedback='+filtersData.clientFeedback;
        }
        if(filtersData.crewFeedback!=='') { 
            ENDPOINT += '&crew_feedback='+filtersData.crewFeedback;
        }
        let deptIds = 0; 
        if(filtersData.departments && filtersData.departments.length)  deptIds = JSON.stringify(filtersData.departments); 
        if(deptIds)  ENDPOINT += '&departments='+deptIds; 

    }
    else {
        let page   = request.data.page;
        let pageSize = request.data.pageSize; 
        let sortBy   = request.data.sortBy; 
        let search   = request.data.search && request.data.search.trim().length > 0 ? request.data.search: 0;  
        ENDPOINT = URL_BASE_API+'events/get-shift-feedback-data/?sort_by='+sortBy+'&page='+page+'&page_size='+pageSize+'&type='+request.data.dataViewType;
        if(search.length > 0) ENDPOINT += '&search='+search;
    }
    return service.get(ENDPOINT);
}

export const feedbackDetails =(request) =>{  
    let shiftId   = request.data.shiftId;
    const ENDPOINT = URL_BASE_API+'events/get-crew-feedback-data/?shift_id='+shiftId+'&type='+request.data.dataViewType;
    return service.get(ENDPOINT);
}

export const feedbackUpdate =(request) =>{  
    let ENDPOINT = '';
    let feedbackId   = request.data.id;
    let ratingType   = request.data.ratingType;
    if(ratingType===0){
        ENDPOINT = URL_BASE_API+'events/update-shift-feedback/'+feedbackId;
    }else{
        ENDPOINT = URL_BASE_API+'events/update-crew-feedback/'+feedbackId;
    }
    delete request.data.id;
    delete request.data.ratingType;
    return service.put(ENDPOINT,request.data);
}

export const feedbackUpdateStarRating =(request) =>{  
    let ENDPOINT = '';
    let feedbackId   = request.data.id;
    let ratingType   = request.data.ratingType;
    if(ratingType===0){
        ENDPOINT = URL_BASE_API+'events/update-shift-star-rating/'+feedbackId;
    }else{
        ENDPOINT = URL_BASE_API+'events/update-crew-star-rating/'+feedbackId;
    }
    delete request.data.id;
    delete request.data.ratingType;
    return service.put(ENDPOINT,request.data);
}

export const feedbackGetChiefReviewersList = () =>{  
    let ENDPOINT = URL_BASE_API+'events/feedback-filter-chief-reviewers/?is_event=1';
    return service.get(ENDPOINT);
}

export const actionTakenShiftGet = (request) =>{  
    let ENDPOINT = URL_BASE_API+'events/shift-feedback-action/'+request.data.feedbackId;
    return service.get(ENDPOINT);
}

export const actionTakenShiftUpdate = (request) => { 
    let feedbackId = request.data.feedbackId;
    const ENDPOINT = URL_BASE_API+'events/shift-feedback-action/'+feedbackId;
    delete request.data.feedbackId;
    return service.put(ENDPOINT,request.data);
};

export const actionTakenCrewGet = (request) =>{  
    let ENDPOINT = URL_BASE_API+'events/crew-feedback-action/'+request.data.feedbackId;
    return service.get(ENDPOINT);
} 

export const actionTakenCrewUpdate = (request) => {
    let feedbackId = request.data.feedbackId;
    const ENDPOINT = URL_BASE_API+'events/crew-feedback-action/'+feedbackId;
    delete request.data.feedbackId;
    return service.put(ENDPOINT,request.data);
};

